module.exports = __webpack_public_path__ + "img/map_body_hotspots_small2.220ce0c8.png";